import { Grid, Typography } from "@mui/material";
import { useParsed } from "@refinedev/core";
import { useDataGrid } from "@refinedev/mui";
import React from "react";
import { CouponAirdrop } from "../../../types/couponAirdrop";
import CreateCouponDialog from "./CreateCouponDialog";
import { DataGrid } from "@mui/x-data-grid";
import { airdropCols } from "tables/airdropCols";
import { useBranch } from "../../../provider/BranchProvider";

export default function AirdropList() {
  const { id: couponTypeId } = useParsed();
  const branch = useBranch();
  const { dataGridProps } = useDataGrid<CouponAirdrop>({
    resource: "coupon-airdrops",
    queryOptions: { refetchOnMount: true, refetchOnWindowFocus: true },
    filters: {
      permanent: [
        { field: "branchId", operator: "eq", value: branch?.id },
        { field: "couponTypeId", operator: "eq", value: couponTypeId },
      ],
    },
  });

  return (
    <Grid container direction={"column"} gap={3}>
      <Typography variant={"subtitle1"} sx={{ mb: -4 }}>
        Coupons can be airdropped to specific members manually.
      </Typography>
      <Grid item justifyContent={"flex-end"} display={"flex"}>
        <CreateCouponDialog />
      </Grid>
      <Grid item>
        <DataGrid
          {...dataGridProps}
          columns={airdropCols(branch!!.id)}
          autoHeight
          sx={{
            ...dataGridProps.sx,
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
          }}
        />
      </Grid>
    </Grid>
  );
}
